<template>
    <div class="bg-wrap">

        <div>
            <Head @changeOn="changeOn"></Head>
        </div>

        <div class="content">
            <div class="item">
                <img class="a" src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/item-expert-1.png" @click="toPro">
            </div>
            <div class="item">
                <img class="a" src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/item-schedule-2.png"  @click="toSchedule">
            </div>

            <div class="item">
                <img class="a" src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/item-tv-2.png"  @click="toTV">
            </div>
<!--            <div class="item right" >-->
<!--                <img class="b" src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/item-history-2.png" @click="toHistory">-->
<!--            </div>-->
        </div>

    </div>
</template>

<script>

    import wx from'weixin-js-sdk'
    import Head from "./HeadIndex"
    export default {
        data() {
            return {
                isOff:false,
            }
        },
        components:{
          Head
        },
        methods: {
            toPro(){
                this.$router.push("/hz/pro")
            },
            toSchedule() {
                this.$router.push("/hz/schedule")
            },
            toHistory() {
                this.$router.push("/hz/history")
            },
            changeOn(val) {
                console.log("onOrOff=" + val)
                if (val) {
                    this.$parent.$refs.audio.pause();
                } else {
                    this.$parent.$refs.audio.play();
                }
            },
            changeOnOff() {
                let oAudio = document.querySelector("#audio");
                if (oAudio != null) {
                    this.tag = true
                    if (this.isOff) {
                        oAudio.play();//让音频文件开始播放
                    } else {
                        oAudio.pause();//让音频文件暂停播放
                    }
                    this.isOff = !this.isOff;
                }

            },
            toTV() {
                this.$router.push({path: "/hz/info"})
            },
            autoPlayAudio() {
                let _this = this
                wx.config({
                    debug: false,
                    appId: '',
                    timestamp: 1,
                    nonceStr: '',
                    signature: '',
                    jsApiList: []
                });
                wx.ready(function() {
                    // document.getElementById('music').play();
                    let a =  _this.$parent.$refs.audio
                    console.log("wx ready")
                    let audio = localStorage.getItem("isOff")
                    let isPaused =a.paused
                    if(audio==null||audio=="false"){
                        if(isPaused){
                            console.log("start music")
                            a.load()
                            a.play();
                        }
                    }else {
                        a.pause();
                    }
                });
            }
        },
        mounted() {
            this.autoPlayAudio()
        },
        beforeDestroy() {
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/bg-2.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        overflow: scroll;
        display: flex;
        flex-direction: column;
        overflow: scroll;
    }
    .content{
        /*flex-grow: 1;*/
        /*display: flex;*/
        /*flex-direction: column;*/
        /*justify-content: space-between;*/
        /*margin:0px 5% 0% 5%;*/
        /*overflow: scroll;*/
        margin-top: -20px;
        .a{
            width: 50%;
            /*object-fit: contain;*/
        }
        .b{
            width: 86%;
            margin-right: -5%;
            /*object-fit: contain;*/
        }
        .item{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-bottom: 10px;
        }
        .left{
            justify-content: flex-start;
        }
        .right{
            justify-content: flex-end;
        }
        .item:first-child{
            opacity: 0;
            animation: slideInLeft .8s ease .5s forwards;
            animation-duration: 0.8s;
            animation-timing-function: ease;
            animation-delay: 0.5s;
            animation-iteration-count: 1;
            animation-direction: normal;
            animation-fill-mode: forwards;
            animation-play-state: running;
            animation-name: slideInLeft;
        }
        .item:nth-child(2){
            opacity: 0;
            animation: slideInLeft .8s ease .7s forwards;
            animation-duration: 0.8s;
            animation-timing-function: ease;
            animation-delay: 0.7s;
            animation-iteration-count: 1;
            animation-direction: normal;
            animation-fill-mode: forwards;
            animation-play-state: running;
            animation-name: slideInLeft;
        }
        .item:nth-child(3){
            opacity: 0;
            animation: slideInLeft .8s ease .9s forwards;
            animation-duration: 0.8s;
            animation-timing-function: ease;
            animation-delay: 0.9s;
            animation-iteration-count: 1;
            animation-direction: normal;
            animation-fill-mode: forwards;
            animation-play-state: running;
            animation-name: slideInLeft;
        }
        .item:nth-child(4){
            opacity: 0;
            animation: slideInLeft .8s ease 1.1s forwards;
            animation-duration: 0.8s;
            animation-timing-function: ease;
            animation-delay: 1.1s;
            animation-iteration-count: 1;
            animation-direction: normal;
            animation-fill-mode: forwards;
            animation-play-state: running;
            animation-name: slideInLeft;
        }
        .item:last-child{
            opacity: 0;
            animation: slideInLeft .8s ease 1.3s forwards;
            animation-duration: 0.8s;
            animation-timing-function: ease;
            animation-delay: 1.3s;
            animation-iteration-count: 1;
            animation-direction: normal;
            animation-fill-mode: forwards;
            animation-play-state: running;
            animation-name: slideInLeft;
        }
    }

    .isOff{
        position: absolute;
        z-index: 100;
        top: 7%;
        right: 5%;
        img{
            width: 30px;
        }
    }

    .isOn{
        position: absolute;
        z-index: 100;
        top: 7%;
        right: 5%;
        animation: rotating 2s linear infinite;
        img{
            width: 30px;
        }
    }

    @keyframes slideInLeft{
        0% {
            -webkit-transform: translateX(80%);
            opacity: 0;
        }
        100% {
            -webkit-transform: translateX(0);
            opacity: 1;
        }
    }

    @keyframes rotating {
        from { -webkit-transform: rotate(0) }
        to { -webkit-transform: rotate(360deg) }
    }

</style>
